module.exports = __webpack_public_path__ + "static/media/Channels with Troopr.54e1fa59.svg";